import { Injectable } from '@angular/core';
import { AuthService } from '../service/auth.service';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root',
})

/**
 * Guard qui autorise l'accès vers le scan 2 ou redirige vers /logByPin.
 */
export class Scan2EmballeurService  {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (this.authService.rights.scan2Emballeur || this.authService.rights.globalAdmin) {
      return true;
    } else {
      // si l'utilisateur ne dispose pas de la permission, on renvoie vers la page de login
      return this.router.createUrlTree(['/' + this.authService.CurrentLoginPage]);
    }
  }
}
